@if (storeMap) {
  <div>
    <bt-map #map [map]="storeMap" [size]="size" [zoom]="zoom" (load)="onMapLoad($event)" [canvasOptions]="{allowTouchScrolling: true}"></bt-map>
  </div>
}
